import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Generate or get visitor ID
const getVisitorId = () => {
  let visitorId = localStorage.getItem('visitor_id');
  if (!visitorId) {
    visitorId = 'v_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('visitor_id', visitorId);
  }
  return visitorId;
};

// Load Google Analytics script
const loadGoogleAnalytics = (measurementId) => {
  if (!measurementId || window.gtag) return;
  
  // Add gtag script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);
  
  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);
};

const AnalyticsTracker = () => {
  const location = useLocation();
  const [gaLoaded, setGaLoaded] = useState(false);

  // Load Google Analytics code from settings
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${API_URL}/api/site-settings.php`);
        if (res.ok) {
          const data = await res.json();
          if (data.google_analytics_id && !gaLoaded) {
            loadGoogleAnalytics(data.google_analytics_id);
            setGaLoaded(true);
          }
        }
      } catch (e) {
        // Silent fail
      }
    };
    fetchSettings();
  }, [gaLoaded]);

  // Track page views
  useEffect(() => {
    // Internal analytics
    const trackVisit = async () => {
      try {
        const visitorId = getVisitorId();
        const page = location.pathname === '/' ? 'homepage' : location.pathname.replace('/', '');
        
        await fetch(`${API_URL}/api/analytics.php?action=track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page,
            visitor_id: visitorId
          })
        });
      } catch (error) {
        // Silent fail
      }
    };

    trackVisit();
    
    // Google Analytics page view
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname
      });
    }
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
